export default {
    apiKey: 'oynfdLZVNr3ym2rCumwiV3qsvAwTjmu8vQh5zFIc',
}